import {
  ArrowsCounterClockwise,
  ArrowsOutLineVertical,
  Broom,
  Chats,
  EnvelopeSimpleOpen,
  FileHtml,
  FilePng,
  FilePpt,
  FileText,
  ListNumbers,
  StackPlus,
  Stamp,
  IconProps,
  Icon,
} from "@phosphor-icons/react";
import { cn } from "@/lib/utils";

const icons: Record<string, Icon> = {
  "merge-pdf": StackPlus,
  "image-to-pdf": FilePng,
  "split-pdf": ArrowsOutLineVertical,
  "delete-pages": Broom,
  "organize-pdf": ArrowsCounterClockwise,
  "html-to-pdf": FileHtml,
  "email-to-pdf": EnvelopeSimpleOpen,
  "chat-with-pdf": Chats,
  "summarize-pdf": FileText,
  "add-watermark": Stamp,
  "pdf-to-ppt": FilePpt,
  "page-numbering": ListNumbers,
};

export function ActionIcon({ id, className, ...props }: { id: string } & IconProps) {
  const Icon = icons[id];
  if (!Icon) return <span className={cn("size-10", className)} />;
  return <Icon weight="light" {...props} className={cn("size-10", className)} />;
}
